import React, { Component } from 'react';
import { Button } from '../../components';

import LogoWhite from '../../assets/img/logo-white.png';
import Logo from '../../assets/img/logo.png';
import AppMockup from '../../assets/img/braxo_app_fuerza_ventas.jpg';
import FacebookIcon from '../../assets/icons/facebook.png';
import GoogleIcon from '../../assets/icons/google.png';
import BackButtonBlue from '../../assets/icons/arrow-left-blue.png';
import { Constants, Globals, axios } from '../../utils';
import { Auth, Sidebar } from "../../services";
import { connect } from 'react-redux';
import Cookies from 'js-cookie';

const STEP = {
  REGISTER: 1,
  PLAN: 2,
  PAYMENT: 3,
}

class Register extends Component {

  state = {
    step: STEP.REGISTER,
    submitted: false,
    showPassword: false,
    showConfirmPassword: false,
    form: {
      name: '',
      lastname: '',
      email: '',
      phone: '',
      password: '',
      password_confirmation: '',
      country_id: '',
      terms_conditions: 0,
    },
    countries: [],
  }

  componentDidMount() {
    this.getCountries();

    const { match } = this.props;

    // Verifica si hay un código de referido en la URL
    if (match && match.params && match.params.referral) {
      // Guardar el código de referido en una cookie
      Cookies.set('referral', match.params.referral, { expires: 365 * 100 }); // Caduca en un año
    }
  }

  getCountries = async () => {
    try {
      const response = await Auth.getCountries('auth/countries');
      const countries = response.countries.map(country => ({ value: country.id, label: country.name }));
      await this.setState({ countries });
      if (response.countries.length > 0) {
        this.onChange(response.countries[0].id, 'country_id');
      }
    } catch (error) {
      Globals.showError();
      console.log(error);
    }
  }

  onChange = async (value, target, e) => {
    await this.setState(state => ({
      form: { ...state.form, [target]: value }
    }));

    if (target === 'country_id') {
      const selectElement = document.getElementById('country_id');
      if (selectElement) selectElement.classList.add('filled');
    }
  }

  gotToStep = (step) => {
    this.setState({ step });
  }

  isValidForm = () => {
    const onError = (msg) => {
      Globals.showError(msg);
      return false;
    }

    const { form } = this.state;

    if (!form.name)
      return onError('Debe indicar el nombre');

    if (!form.lastname)
      return onError('Debe indicar el apellido');

    if (!form.email)
      return onError('Debe indicar el correo');

    if (!form.phone)
      return onError('Debe indicar el teléfono');

    if (!form.password)
      return onError('Debe indicar la contraseña');

    if (form.password !== form.password_confirmation)
      return onError('Las contraseñas no coinciden');

    if (form.terms_conditions !== Constants.STATUS_ACTIVE)
      return onError('Debe aceptar los términos y condiciones');

    return true;
  }

  onSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!this.isValidForm()) return;

    Globals.setLoading();

    try {
      let form = { ...this.state.form }

      // Obtén la cookie 'referral'
      const referralCode = Cookies.get('referral');
      console.log('Referral Code:', referralCode);

      if (referralCode) {
        form.referral_code = referralCode
      }

      await Auth.register(form);
      this.authenticate();

    } catch (error) {
      console.log(error);
      Globals.showError(error?.error);
    }

    Globals.quitLoading();
  };

  authenticate = () => {
    const form = {
      email: this.state.form.email,
      password: this.state.form.password
    }
    Auth.authenticate(form)
      .then(({ user, token, message }) => {
        console.log(user, token, message)
        if (message !== null) Globals.showWarning(message);

        this.props.dispatch({ type: "SET_USER", payload: user });
        this.props.dispatch({ type: "SET_ADMIN", payload: Globals.setTypeRole(user) });
        localStorage.setItem("token", JSON.stringify(token));

        return user;
      })
      .then(user => {
        console.log(user)
        if (!user) return;

        Sidebar.getModuleByUser(user.id)
          .then(modules => {
            this.props.dispatch({ type: "SET_SIDEBAR", payload: modules });
            this.props.history.push('/dashboard');
          })
          .catch(error => console.log({ error: error }))
          .finally(() => this.setState({ submitted: false }));
      })
      .catch(error => console.log(error))
      .finally(() => this.setState({ submitted: false }));
  }

  registerGoogle = () => {

  }

  registerFacebook = () => {

  }

  getPasswordStrength = () => {
    const { password } = this.state.form;
    if (!password) return { label: 'Sin contraseña', color: '#8a94a8', level: 0 };
    if (password.length > 8 && /[A-Z]/.test(password) && /[0-9]/.test(password)) return { label: 'Fuerte', color: '#00d8a8', level: 4 };
    if (password.length > 6) return { label: 'Media', color: '#ffa500', level: 2 };
    return { label: 'Débil', color: '#ff4d4d', level: 1 };
  }

  render() {

    const { form } = this.state;
    const strength = this.getPasswordStrength();

    return (
      <div id="register">
        <main className="registration-page">
          <div className="registration-shell">
            <section className="form-panel">
              <div className="form-content">
                <header className="form-header">
                  <div className="row gx-3 gy-2">
                    <div style={{ width: '39%' }} className="col-md-6">
                      <a href="#" onClick={(e) => { e.preventDefault(); this.props.history.goBack(); }} className="back-link">
                        <i className="fa fa-arrow-left"></i> Volver al inicio
                      </a>
                    </div>
                    <div className="col-md-6">
                      <img src={Logo} alt="Braxo" className="brand-logo" />
                    </div>
                    <div className="strength-track" style={{ visibility: 'hidden' }}></div>
                  </div>
                </header>

                <div className="form-heading text-center">
                  <h1>Crea tu cuenta en <span>Braxo</span></h1>
                  <p>Únete a miles de negocios que ya gestionan sus ventas de forma inteligente.</p>
                </div>

                <form id="registerForm" noValidate onSubmit={this.onSubmit}>
                  <div className="row gx-3 gy-2">
                    <div className="col-md-6">
                      <label htmlFor="firstName" className="form-label">Nombre</label>
                      <div className="input-icon-wrap">
                        <i className="fa fa-user-o"></i>
                        <input type="text" className="form-control" id="firstName" placeholder="Ingresa tu nombre"
                          value={form.name} onChange={e => this.onChange(e.target.value, 'name')} required />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="lastName" className="form-label">Apellidos</label>
                      <div className="input-icon-wrap">
                        <i className="fa fa-user-o"></i>
                        <input type="text" className="form-control" id="lastName" placeholder="Ingresa tus apellidos"
                          value={form.lastname} onChange={e => this.onChange(e.target.value, 'lastname')} required />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="email" className="form-label">Correo electrónico</label>
                      <div className="input-icon-wrap">
                        <i className="fa fa-envelope-o"></i>
                        <input type="email" className="form-control" id="email" placeholder="ejemplo@correo.com"
                          value={form.email} onChange={e => this.onChange(e.target.value, 'email')} required />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="phone" className="form-label">Teléfono</label>
                      <div className="input-icon-wrap">
                        <i className="fa fa-phone"></i>
                        <input type="tel" className="form-control" id="phone" placeholder="+58 412 123 4567"
                          value={form.phone} onChange={e => this.onChange(e.target.value, 'phone')} required />
                      </div>
                    </div>

                    <div className="col-12">
                      <label htmlFor="country" className="form-label">País</label>
                      <div className="input-icon-wrap country-wrap">
                        <i className="fa fa-flag-o"></i>
                        <select className="form-select" id="country"
                          value={form.country_id} onChange={e => this.onChange(e.target.value, 'country_id', e)} required>
                          {this.state.countries.map(c => (
                            <option key={c.value} value={c.value}>{c.label}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="password" className="form-label">Contraseña</label>
                      <div className="input-icon-wrap password-wrap">
                        <i className="fa fa-lock"></i>
                        <input type={this.state.showPassword ? "text" : "password"} className="form-control" id="password"
                          placeholder="Crea una contraseña" minLength="6"
                          autoComplete="new-password" value={form.password}
                          onChange={e => this.onChange(e.target.value, 'password')} required />
                        <button type="button" className="password-toggle" onClick={() => this.setState({ showPassword: !this.state.showPassword })}>
                          <i className={this.state.showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                        </button>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="confirmPassword" className="form-label">Repetir contraseña</label>
                      <div className="input-icon-wrap password-wrap">
                        <i className="fa fa-lock"></i>
                        <input type={this.state.showConfirmPassword ? "text" : "password"} className="form-control" id="confirmPassword"
                          placeholder="Confirma tu contraseña" minLength="6"
                          autoComplete="new-password" value={form.password_confirmation}
                          onChange={e => this.onChange(e.target.value, 'password_confirmation')} required />
                        <button type="button" className="password-toggle" onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}>
                          <i className={this.state.showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="password-security">
                    <div className="d-flex align-items-center gap-2">
                      <span>Seguridad de la contraseña:</span>
                      <strong className="strength-label" style={{ color: strength.color }}>{strength.label}</strong>
                    </div>
                    <div className="strength-track">
                      <div className="strength-bar" style={{ width: `${strength.level * 25}%`, backgroundColor: strength.color }}></div>
                    </div>
                    <small id="passwordHint">
                      Mínimo 6 caracteres. Para mayor seguridad combina letras, números y símbolos.
                    </small>
                  </div>

                  <hr className="form-divider" />

                  <div className="form-check terms-check">
                    <input className="form-check-input" type="checkbox" id="terms"
                      checked={form.terms_conditions === Constants.STATUS_ACTIVE}
                      onChange={() => {
                        this.setState(state => ({
                          form: {
                            ...state.form,
                            terms_conditions: state.form.terms_conditions === Constants.STATUS_ACTIVE
                              ? Constants.STATUS_INACTIVE
                              : Constants.STATUS_ACTIVE,
                          }
                        }));
                      }} required />
                    <label className="form-check-label" htmlFor="terms">
                      Acepto los <a href="https://sysge24.com/terminos_condiciones_SYSGE24-2510.pdf" target="_blank" rel="noopener noreferrer">términos y condiciones</a> y la <a href="#">política de privacidad</a>
                    </label>
                  </div>

                  {/* 
                  <div className="social-separator">
                    <span>O regístrate con</span>
                  </div>

                  <div className="row g-2">
                    <div className="col-md-6">
                      <button type="button" className="btn social-login-btn" onClick={this.registerGoogle}>
                        <span className="google-icon"><img src={GoogleIcon} alt="G" /></span>
                        Continuar con Google
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button type="button" className="btn social-login-btn" onClick={this.registerFacebook}>
                        <span className="facebook-icon"><img src={FacebookIcon} alt="F" /></span>
                        Continuar con Facebook
                      </button>
                    </div>
                  </div>
                  */}

                  <button className="btn create-account-btn" type="submit" disabled={form.terms_conditions === Constants.STATUS_INACTIVE}>
                    Crear cuenta
                  </button>

                  <div className="login-sticky">
                    <p style={{ fontSize: '16px' }} className="login-text text-center mb-0">
                      ¿Ya tienes cuenta? <span className="link-primary" onClick={() => this.props.history.push('/login')}>Inicia sesión</span>
                    </p>
                  </div>
                </form>
              </div>
            </section>

            <aside className="image-panel" aria-label="Beneficios de Braxo">
              <img src={AppMockup} alt="Braxo, aplicación para fuerza de ventas" />
            </aside>
          </div>
        </main>
      </div>
    )
  }
}

export default connect()(Register)